<template>
    <tr>
        <td>{{ row.id }}</td>
        <td>
            {{ row.name }}<br>
            <small><a :href="row.indeed_url">{{ row.indeed_url }}</a></small><br>
            <small><a :href="row.intelliapp_url">{{ row.intelliapp_url }}</a></small>
        </td>
        <td>
            <b v-if="row.usdot">
                {{ row.usdot }}<br>
            </b>
            <small>{{ row.usdot_state }}</small>
        </td>
        <td>
            <el-autocomplete
                v-model="search"
                :fetch-suggestions="searchByName"
                placeholder=""
                @select="handleSelect"
                style="width: 100%"
            >
                <template slot-scope="{item}">
                    <i v-if="item.is_custom">
                        {{ item.value }}
                    </i>
                    <div v-else style="display: flex; flex-direction: column; width: 100%">
                        <div>
                            <b>{{ item.value }} ({{ item.usdot }})</b>
                        </div>
                        <div style="line-height: 1.5; font-size: 12px; padding-bottom: 5px">
                            <span v-for="(info, index) in item.infos" :key="index">
                                {{ info }}<br />
                            </span>
                        </div>
                    </div>
                </template>
            </el-autocomplete>
            <small v-if="row.rigdid_name">
                <br>{{ row.rigdid_name }}
            </small>
            <small v-if="row.rigdid_name_alternate && row.rigdid_name != row.rigdid_name_alternate">
                <br>{{ row.rigdid_name_alternate }}
            </small>
        </td>
        <!-- <td>
            {{ row.cg_post_count }} posts
        </td> -->
        <td>
            {{ row.id_post_count }} posts<br>
            <small v-for="(post, index) in row.indeed_posts" :key="index">
                <a :href="post.post_url">{{ post.title }}</a><br>
            </small>
        </td>
        <td>
            {{ row.indeed_reviews }}
        </td>
        <td>
            <small v-for="(email, index) in row.emails" :key="index">
                {{ email }}<br />
            </small>
        </td>
        <td>
            <small v-for="(link, index) in row.links" :key="index">
                {{ link }}<br />
            </small>
        </td>
    </tr>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            search: this.row.rigdid_name ? this.row.rigdid_name : this.row.name,
            usdotSuggestions: [],
        };
    },
    methods: {
        searchByName(queryString, cb) {
            axios.post(url(`admin/prospects/usdots/search`), {
                name: queryString
            }).then((response) => {
                cb(response.data.results);
            });
        },
        handleSelect(item) {
            axios.post(url(`admin/prospects/usdots/assign`), {
                scraper_employer_id: this.row.id,
                usdot: item.usdot
            }).then((response) => {
                this.$emit('refresh');
            });
        }
    }
}
</script>